(() => {
  const key = 'mebore_item_attribution_v1';

  const read = () => {
    try { return JSON.parse(window.sessionStorage.getItem(key) || '{}'); }
    catch (_) { return {}; }
  };
  const write = value => {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); }
    catch (_) { /* Storage can be unavailable in privacy modes. */ }
  };

  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-source-section-id][data-item-id]');
    if (!link) return;
    const record = {
      item_id: link.dataset.itemId,
      source_section_id: link.dataset.sourceSectionId || 'unknown',
      same_day_shipping: link.dataset.sameDayShipping || 'unknown',
      captured_at: Date.now()
    };
    const state = read();
    state.latest = record;
    state.items = state.items || {};
    state.items[String(record.item_id)] = record;
    write(state);
  }, true);

  const selectedSameDayShipping = root => {
    const fulfillment = root.querySelector('[data-fulfillment-line]');
    if (!fulfillment) return null;
    let eligibility;
    try {
      eligibility = JSON.parse(fulfillment.dataset.shippingEligibility || '{}');
    } catch (_) {
      return null;
    }
    const scope = root.closest('.shopify-section') || root;
    const picker = scope.querySelector('variant-radios, variant-selects');
    const variantId = picker?.currentVariant?.id
      || scope.querySelector('product-form input[name="id"]')?.value;
    const status = eligibility[String(variantId)];
    if (!status) return null;
    return Number(status.sd) === 1 ? 'true' : 'false';
  };

  const hydrateProductForms = () => {
    const root = document.querySelector('[data-mebore-product-root]');
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const state = read();
    const itemId = root.dataset.itemId;
    const stored = state.items?.[String(itemId)] || state.latest || {};
    const sourceSectionId = params.get('source_section_id') || stored.source_section_id || 'unknown';
    const sameDayShipping = selectedSameDayShipping(root)
      || root.dataset.sameDayShipping
      || 'false';
    root.dataset.sameDayShipping = sameDayShipping;

    root.dataset.sourceSectionId = sourceSectionId;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.dataset.itemId = itemId;
      form.dataset.sourceSectionId = sourceSectionId;
      form.dataset.sameDayShipping = sameDayShipping;
      const fields = {
        'properties[_source_section_id]': sourceSectionId,
        'properties[_same_day_shipping]': sameDayShipping
      };
      Object.entries(fields).forEach(([name, value]) => {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.append(input);
        }
        input.value = value;
      });
    });

    window.dispatchEvent(new CustomEvent('mebore:attribution-ready', { detail: { item_id: itemId, source_section_id: sourceSectionId, same_day_shipping: sameDayShipping } }));
  };

  const revealLinkedReview = () => {
    const reviewId = new URLSearchParams(window.location.search).get('review_id');
    if (!reviewId) return;
    let attempts = 0;
    const findReview = () => {
      const review = [...document.querySelectorAll('.jdgm-rev[data-review-id]')]
        .find(item => item.dataset.reviewId === reviewId);
      if (!review && attempts < 40) {
        attempts += 1;
        window.setTimeout(findReview, 250);
        return;
      }
      if (!review) return;
      review.id = `judgeme-review-${reviewId}`;
      review.dataset.linkedFromHome = 'true';
      review.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    findReview();
  };

  window.MeboreAttribution = { read, hydrateProductForms, revealLinkedReview };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { hydrateProductForms(); revealLinkedReview(); }, { once: true });
  else { hydrateProductForms(); revealLinkedReview(); }
  document.addEventListener('shopify:section:load', hydrateProductForms);
  document.addEventListener('change', event => {
    const root = document.querySelector('[data-mebore-product-root]');
    const scope = root?.closest('.shopify-section') || root;
    if (!scope?.contains(event.target)) return;
    window.setTimeout(hydrateProductForms, 0);
    window.setTimeout(hydrateProductForms, 180);
  });
})();
